module.exports = __webpack_public_path__ + "img/menu_logo_unexpand.b691262e.png";